import React from "react";
import "../../App.css";
import i18next from "../../i18n";
import { Helmet } from "react-helmet-async";
import article_img_3 from "../../images/articles/linkNordic-parner.jpg";

function LinkNordicPartnership() {
  return (
    <div className="min-h-screen bg-white">
      <Helmet>
        <title>
          {i18next.t("pages.articles.list.linkNordicPartnership.title")}
        </title>
        <meta
          name="description"
          content={i18next.t(
            "pages.articles.list.linkNordicPartnership.description"
          )}
        />
        <link rel="canonical" href="https://xperconsulting.no/artikler/link-nordic-partnership" />
      </Helmet>
      <div className="container max-w-xl pt-36 justify-start items-center text-main-dark flex flex-col md:flex-row pb-24 md:gap-16">
        <div className="w-full md:w-3/5 text-left">
          <h1 className="text-5xl font-bold text-main-dark mb-2">
            {i18next.t("pages.articles.list.linkNordicPartnership.title")}
          </h1>
          <p className="text-lg text-secondary">
            {i18next.t("pages.articles.list.linkNordicPartnership.date")}
          </p>
        </div>
        <div className="w-full md:w-2/5 text-left">
          <img
            className="w-full h-full object-cover"
            src={article_img_3}
            alt={i18next.t(
              "pages.articles.list.linkNordicPartnership.imageAlt"
            )}
          />
        </div>
      </div>
      <div className="bg-gray">
        <div className="container max-w-xl text-xl text-left py-24 text-main-dark">
          <div className="max-w-sm">
            <p>
              {i18next.t(
                "pages.articles.list.linkNordicPartnership.sections.intro.content"
              )}
              <a href="/ccm" className=" underline hover:text-contrast-ink">
                {i18next.t("pages.articles.list.linkNordicPartnership.sections.intro.link")}
              </a>
              {i18next.t("pages.articles.list.linkNordicPartnership.sections.intro.content2")}
            </p>
            <p>
              –{" "}
              {i18next.t(
                "pages.articles.list.linkNordicPartnership.sections.intro.quote.content"
              )}
              {i18next.t(
                "pages.articles.list.linkNordicPartnership.sections.intro.quote.author"
              )}
              .
            </p>

            <h2 className="text-3xl font-bold mt-12 mb-2">
              {i18next.t(
                "pages.articles.list.linkNordicPartnership.sections.complementaryPartnership.title"
              )}
            </h2>
            <p>
              {i18next.t(
                "pages.articles.list.linkNordicPartnership.sections.complementaryPartnership.content"
              )}
            </p>
            <p>
              –{" "}
              {i18next.t(
                "pages.articles.list.linkNordicPartnership.sections.complementaryPartnership.quote.content"
              )}
              {i18next.t(
                "pages.articles.list.linkNordicPartnership.sections.complementaryPartnership.quote.author"
              )}
              .
            </p>

            <h2 className="text-3xl font-bold mt-12 mb-2">
              {i18next.t(
                "pages.articles.list.linkNordicPartnership.sections.docEngine.title"
              )}
            </h2>
            <p>
              {i18next.t(
                "pages.articles.list.linkNordicPartnership.sections.docEngine.content"
              )}
              <a href="/docengine" className=" underline hover:text-contrast-ink">
                {i18next.t("pages.articles.list.linkNordicPartnership.sections.docEngine.link")}
              </a>
              {i18next.t("pages.articles.list.linkNordicPartnership.sections.docEngine.content2")}
            </p>
            <p>
              –{" "}
              {i18next.t(
                "pages.articles.list.linkNordicPartnership.sections.docEngine.quote.content"
              )}
              {i18next.t(
                "pages.articles.list.linkNordicPartnership.sections.docEngine.quote.author"
              )}
              .
            </p>

            <h2 className="text-4xl font-bold mt-12 mb-2">
              {i18next.t(
                "pages.articles.list.linkNordicPartnership.sections.euDirective.title"
              )}
            </h2>
            <p className="text-xl mb-4">
              {i18next.t(
                "pages.articles.list.linkNordicPartnership.sections.euDirective.content"
              )}
            </p>
            <p>
              –{" "}
              {i18next.t(
                "pages.articles.list.linkNordicPartnership.sections.euDirective.quote.content"
              )}
              {i18next.t(
                "pages.articles.list.linkNordicPartnership.sections.euDirective.quote.author"
              )}
              .
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default LinkNordicPartnership;
